import * as THREE from "three";

class PaintingAllieChat {
  constructor(mesh) {
    this._mesh = mesh;
    this._startingPosition = new THREE.Vector3(-1.95, 3.65, 6.15);
    this._startingLookAt = new THREE.Vector3(-1.95, 3.65, -20);

    this._mesh.position.copy(this._startingPosition);
    this._mesh.lookAt(this._startingLookAt);

    this._mesh.traverse((x) => {
      if (x instanceof THREE.Mesh) {
        switch (x.material.name) {
          case "AllieChat_PaintingTexture":
            this._paintingTexture = x;
            this._paintingMaterialOrig = x.material;
            this._paintingMaterial = new THREE.MeshBasicMaterial({
              map: x.material.map,
              name: x.name,
            });
            break;
          case "VisitTheSite":
            x.visible = false;
            break;
          default:
            break;
        }
      }
    });
  }
  setLinksActive = (isActive) => {
  };
  setMaterial = (isShowingPaining) => {
    this._paintingTexture.material = isShowingPaining ? this._paintingMaterial : this._paintingMaterialOrig;
  };
  getLinkUrl = (mesh) => {
    return undefined;
  };
  get name() {
    return "Allie.Chat";
  }
  get mesh() {
    return this._mesh;
  }
  get startingPosition() {
    return this._startingPosition;
  }
  get startingLookAt() {
    return this._startingLookAt;
  }
}
export default PaintingAllieChat;
